import styled from '@emotion/styled'
import { breakpoints, colors, fonts, fontSizes } from 'src/utils/styles'
import { IS_BLACK_FRIDAY } from 'src/utils/globals'
import { css } from '@emotion/react'
import CloseSvg from 'src/static/icons/svg/ll_close.svg'
import CloseSvgWhite from 'src/static/icons/svg/dark-mode/ll_close_white.svg'

export const StFilterSideBarMobile = styled.div`
  display: none;

  @media (max-width: ${breakpoints.l}px) {
    display: flex;
    flex-direction: column;

    transform: ${props => (props.isOpen ? 'translateY(0)' : 'translateY(100%)')};
    transition: transform 0.2s ease-in-out;
    position: fixed;
    z-index: 5;
    background-color: ${IS_BLACK_FRIDAY ? 'black' : 'white'};
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    overflow: scroll;
  }
`

export const CloseButtonStyles = css`
  width: 20px;
  height: 20px;
`

export const StCloseButton = styled.button`
  all: unset;
  cursor: pointer;
  margin-top: 1.4em;

  @media (max-width: ${breakpoints.l}px) {
    margin-top: 5px;
  }
`

export const StCloseButtonIcon = styled(CloseSvg)`
  ${CloseButtonStyles};
`

export const StCloseButtonIconWhite = styled(CloseSvgWhite)`
  ${CloseButtonStyles};
`

export const StHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  border-bottom: 1px solid #3331314d;
  margin: 1.1em 15px 0.3em;
  padding-bottom: 1em;
`

export const StTitle = styled.span`
  font-family: ${fonts.extendedBold};
  font-size: ${fontSizes.sidebarMobileHeadline};
`

export const ShowAllProductsButton = styled.button`
  align-self: center;
  background-color: ${colors.lemonadeYellow};
  border: 2px solid ${colors.lemonadeYellow};
  color: ${IS_BLACK_FRIDAY ? 'black' : '#333131'};
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: ${fontSizes.addToBagButton};
  font-family: ${fonts.regular};
  width: 95%;
  padding: 0.65rem 2.7rem 0.85rem 2.7rem;
  bottom: 30px;
  margin: auto 1em 3.5em;
  cursor: pointer;
  white-space: nowrap;

  @media (max-width: ${breakpoints.s}px) {
    font-size: ${fontSizes.addToBagButtonMobile};
  }
`
